module.exports = function() {
  return new Worker(__webpack_public_path__ + "ed882c03ec7198766f4e.worker.js");
};